import {
  AfterViewInit,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import testTheme from './theme.json';
import { ApiService } from 'src/services/api.service';
import { BaseComponent } from './themes/base/base.component';
import { SecondaryComponent } from './themes/secondary/secondary.component';
import { LogoService } from './services/logo.service';
import { ThemeService } from './services/theme.service';
import { MessageService } from './services/message.service';
import { QuestionarioService } from './services/questionario.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit {
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private api: ApiService,
    private logoService: LogoService,
    private themeService: ThemeService,
    private messageService: MessageService,
    private questionarioService: QuestionarioService
  ) {}
  @ViewChild('dynamicComponentContainer', { read: ViewContainerRef })
  dynamicComponentContainer: ViewContainerRef | undefined;
  componentRef: ComponentRef<any> | undefined;
  title = 'hr-front-mobile';
  loaded = false;
  theme = 'base';
  logo!: string;
  errorPage: boolean = false;
  token: string = 'e674cfc1-d2d7-4f57-9836-8f1ee5ae0c64';
  data: any;

  ngAfterViewInit() {
    document.body.style.setProperty('--primary', 'white');
  }

  showMessage(message: string, status: string) {
    this.messageService.showMessage(message, status);
  }

  changeTheme() {
    // this.theme = this.theme === 'base' ? 'secondary' : 'base';
    // this.loadComponentBasedOnTheme();
  }
  loadComponentBasedOnTheme(theme: string) {
    // Sostituisci "theme" con la tua variabile o condizione che determina il tema

    // Seleziona il componente in base alla variabile di tema
    const componentMap: { [key: string]: any } = {
      base: BaseComponent,
      secondary: SecondaryComponent,
    };

    const componentToLoad = componentMap[theme];

    // Crea un factory per il componente selezionato
    const componentFactory =
      this.componentFactoryResolver.resolveComponentFactory(componentToLoad);

    // Cancella il contenuto del contenitore dinamico prima di caricare il nuovo componente
    if (this.dynamicComponentContainer) {
      this.dynamicComponentContainer.clear();

      // Carica dinamicamente il componente selezionato nel contenitore dinamico
      this.componentRef =
        this.dynamicComponentContainer.createComponent(componentFactory);
    }
  }

  blockClick(event: any) {
    event.preventDefault();
  }

  ngOnInit(): void {
    if (true) {
    }
    const urlObj = new URL(window.location.href);
    if (urlObj.pathname.split('/')[2]) {
      this.setAzienda();
      this.questionarioService.getSurveyByToken(urlObj.pathname.split('/')[2]);
    } else {
      this.loaded = true;
      this.errorPage = true;
    }
  }

  getCompanyDomain() {
    const urlObj = new URL(window.location.href);
    if (urlObj.searchParams.get('company')) {
      return urlObj.searchParams.get('company');
    } else {
      return window.location.host;
    }
  }

  setAzienda() {
    const urlObj = new URL(window.location.href);
    const company = this.getCompanyDomain();

    this.api
      .get(
        `${
          urlObj.searchParams.get('company')
            ? '/companies/'
            : '/companies/url?domain='
        }${company}`
      )
      .subscribe({
        next: (res: any) => {
          const data = res?.data;
          this.data = data;
          this.logoService.setLogo(data.logo);
          this.themeService.setPrimaryColor(data.color_primary);
          this.themeService.setSecondaryColor(data.color_secondary);
          this.themeService.setTertiaryColor(data.color_tertiary);
          this.themeService.setQuaternaryColor(data.color_quaternary);
          this.theme = data.theme;
          document.body.style.setProperty('--primary', data.color_primary);
          document.body.style.setProperty('--secondary', data.color_secondary);
          document.body.style.setProperty('--tertiary', data.color_tertiary);
          document.body.style.setProperty(
            '--quaternary',
            data.color_quaternary
          );
          document.body.style.setProperty(
            '--btn-primary',
            'rgba(255, 255, 255, 0.25)'
          );
          this.loaded = true;
          this.loadComponentBasedOnTheme(data?.theme ? data.theme : 'base');
        },
        error: (err) => {
          this.showMessage('Errore nel caricamento dei dati', 'error');
        },
        complete: () => {
          if (this.data === null) {
            this.loaded = true;
            this.errorPage = true;
          }
        },
      });
  }
}
